<template>
  <v-layout column>
    <v-stepper v-model="stepperIndex" vertical>
      <v-container text-xs-center>
        <h2 class="title">New Lot</h2>
      </v-container>
      <v-stepper-step editable :complete="stepperIndex > 1" step="1">
        {{processor.name}}
      </v-stepper-step>

      <v-stepper-content step="1">
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 class="no-border-input">
                <v-text-field label="Address" :hide-details="true" v-model="processor.address" disabled></v-text-field>
              </v-flex>
              <v-flex xs6 class="no-border-input">
                <v-text-field label="City" :hide-details="true" v-model="processor.city" disabled></v-text-field>
              </v-flex>
              <v-flex xs6 class="no-border-input">
                <v-text-field label="Country" :hide-details="true" v-model="countriesList[processor.country_code]" disabled></v-text-field>
              </v-flex>

              <v-flex xs6>
                <v-text-field :disabled="!!this.lot.id" label="Lot Number" v-model="lotForm.id" @input="$v.lotForm.id.$touch()" @blur="$v.lotForm.id.$touch();slugifyId()" :error-messages="getLotFormErrorMessage('id')" ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-menu
                  v-model="lotForm.powderShipmentDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="lotForm.shipped_at"
                    label="Powder Shipment Date"
                    :error-messages="getLotFormErrorMessage('shipped_at')"
                    append-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker no-title v-model="lotForm.shipped_at" @blur="$v.lotForm.shipped_at.$touch()"  @input="lotForm.powderShipmentDateMenu = false; $v.lotForm.shipped_at.$touch()"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
              <v-select :items="ingredients" item-text="name" item-value="id" label="Type of Meat"
                v-model="lotForm.ingredient"
                @input="$v.lotForm.ingredient.$touch()"
                @blur="$v.lotForm.ingredient.$touch()"
                :error-messages="getLotFormErrorMessage('ingredient')"
              ></v-select>
          </v-flex>
            </v-layout>
          </v-container>
          <v-layout align-center justify-end row>
            <v-btn @click="handleClose()" flat color="primary">cancel</v-btn>
            <v-btn @click="validateLotFormInfos()" raised color="primary">next</v-btn>
          </v-layout>
        </form>
      </v-stepper-content>

      <v-stepper-step :complete="stepperIndex > 2" step="2">
        Shipment from Farms
      </v-stepper-step>

      <v-stepper-content step="2">
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs-6 v-for="(shipment, index) in shipmentForm" :key="`shipments-existing-${index}`" class="shipment-row" >
                <div v-if="!shipment.lot && index >= 1" class="delete-shipment-row-btn">
                  <v-btn @click="handleDeleteShipment(index)" icon>
                    <v-icon color="red">remove_circle_outline</v-icon>
                  </v-btn>
                </div>
                <v-layout row>
                  <v-flex shrink class="index font-weight-regular">
                    {{index + 1}}
                  </v-flex>
                  <v-flex grow>
                    <v-text-field v-if="shipment.created_at" label="Shipment Number"  v-model="shipment.id" disabled></v-text-field>

                    <v-autocomplete
                      v-if="!shipment.created_at"
                      :items="filteredShipmentList()"
                      item-text="id"
                      item-value="id"
                      item-disabled="exists"
                      v-model="shipment.id"
                      label="Shipment"
                      :error-messages="getShipmentErrorMessage('id', index)"
                      @input="$v.shipmentForm.$each.$iter[index].id.$touch()"
                      @blur="$v.shipmentForm.$each.$iter[index].id.$touch()"
                    ></v-autocomplete>

                    <v-menu
                      v-model="shipment.receivingDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="shipment.received_at"
                        label="Receiving Date"
                        :error-messages="getShipmentErrorMessage('received_at', index)"
                        append-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker no-title v-model="shipment.received_at" @input="shipment.receivingDateMenu = false; $v.shipmentForm.$each.$iter[index].received_at.$touch()"></v-date-picker>
                    </v-menu>

                    <v-menu
                      v-model="shipment.processingDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="shipment.processed_at"
                        label="Processing Date"
                        :error-messages="getShipmentErrorMessage('processed_at', index)"
                        append-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker no-title v-model="shipment.processed_at" @input="shipment.processingDateMenu = false; $v.shipmentForm.$each.$iter[index].processed_at.$touch()"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
          <v-layout align-center justify-end row>
            <v-flex grow>
              <v-btn flat color="primary" @click="addShipment()">Add shipment</v-btn>
            </v-flex>
            <v-btn @click="handleClose()" flat color="primary">cancel</v-btn>
            <v-btn @click="validateShipmentInfos()" raised color="primary">submit</v-btn>
          </v-layout>
        </form>
      </v-stepper-content>

    </v-stepper>
  </v-layout>

</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { countriesList } from '@/utils/countries'
import slugify from '@sindresorhus/slugify'

export default {
  name: 'LotForm',
  props: ['lotId', 'lot', 'shipments'],
  computed: {
    ...mapGetters({
      getUnprocessedShipmentListForIngredient: 'getUnprocessedShipmentListForIngredient',
      loading: 'shipmentLoading',
      ingredients: 'ingredients',
      processor: 'processor'
    })
  },
  data () {
    return {
      // Replace plant with user account plant infos
      countriesList,
      stepperIndex: 1,
      lotValidationErrorMsg: {},
      lotForm: {
        id: '',
        shipped_at: '',
        ingredient: '',
        location: null
      },
      shipmentForm: [{
        id: '',
        received_at: '',
        processed_at: ''
      }]
    }
  },
  validations () {
    return {
      lotForm: {
        id: { required },
        shipped_at: { required },
        ingredient: { required }
      },
      shipmentForm: {
        $each: {
          id: { required },
          received_at: { required },
          processed_at: { required }
        }
      }
    }
  },
  created () {
    if (this.lot && this.lot.id) {
      this.lotForm = {
        ...this.lot
      }
    }

    if (this.shipments.length) {
      this.shipmentForm = JSON.parse(JSON.stringify(this.shipments))
    }
  },
  methods: {

    filteredShipmentList () {
      let shipments = this.$store.getters.getUnprocessedShipmentListForIngredient(this.lotForm.ingredient)

      shipments.forEach((shipment) => {
        let found = this.shipmentForm.find((s) => {
          return s.id === shipment.id
        })
        if (found) {
          shipment.exists = true
        } else {
          shipment.exists = false
        }
      })
      return shipments
    },

    handleDeleteShipment (index) {
      this.shipmentForm.splice(index, 1)
    },

    slugifyId () {
      this.lotForm.id = slugify(this.lotForm.id, { lowercase: false, decamelize: false })
    },

    handleClose () {
      this.$emit('on-close-dialog')
    },

    addShipment () {
      let newShipment = {
        id: '',
        received_at: '',
        processed_at: ''
      }

      this.shipmentForm.push(newShipment)
    },

    getShipmentErrorMessage (field, index) {
      let errors = []

      if (!this.$v.shipmentForm.$each.$iter[index][field].$dirty) return errors
      for (let key in this.$v.shipmentForm.$each.$iter[index][field].$params) {
        // Add more key here is needed for other type of error messages
        if (key === 'required') !this.$v.shipmentForm.$each.$iter[index][field].required && errors.push('This field is is required.')
      }

      return errors
    },

    getLotFormErrorMessage (field) {
      let errors = []

      if (!this.$v.lotForm[field].$dirty) return errors
      for (let key in this.$v.lotForm[field].$params) {
        // Add more key here is needed for other type of error messages
        if (key === 'required') !this.$v.lotForm[field].required && errors.push('This field is is required.')
      }

      if (this.lotValidationErrorMsg[field]) {
        errors.push(this.lotValidationErrorMsg[field][0])
      }

      return errors
    },

    validateLotFormInfos () {
      if (this.$v.lotForm.$invalid) {
        this.$v.lotForm.$touch()
      } else {
        this.stepperIndex = 2
      }
    },

    validateShipmentInfos () {
      if (this.$v.shipmentForm.$invalid) {
        this.$v.shipmentForm.$touch()
      } else {
        this.createLot()
      }
    },

    updateShipments (lotId) {
      let promises = []

      this.shipmentForm.forEach((shipment) => {
        shipment.lot = lotId
        promises.push(this.$store.dispatch('updateShipment', { shipment: shipment }))
      })

      Promise.all(promises).then(() => {
        this.$store.dispatch('showSnackBar', { message: 'Lot created successfully.' })
        this.$emit('on-close-dialog')
      }).catch((err) => {
        this.$store.dispatch('showSnackBar', { message: err })
      })
    },

    createLot () {
      let lotData = JSON.parse(JSON.stringify(this.lotForm))
      lotData.location = this.processor.id
      this.$store.dispatch('checkLotId', lotData.id).then((res) => {
        if (res === 'exists') {
          // Update Lot
          this.$store.dispatch('updateLot', { lot: lotData }).then((lotId) => {
            this.updateShipments(lotId)
          })
        } else {
          this.$store.dispatch('createLot', { lot: lotData }).then((lotId) => {
            this.updateShipments(lotId)
          }).catch((err) => {
            this.stepperIndex = 1
            for (let key in err.response.data) {
              this.lotValidationErrorMsg[key] = err.response.data[key]
            }
          })
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>

.flex {
  padding: 5px;
}

.index {
  font-size: 24px;
  color: black;
  opacity: 0.3;
  margin-right: 10px;
}

.shipment-row{
  margin-top: 10px !important;
  position: relative;
  padding: 20px 10px !important;
  background: #fafafa;
}

.delete-shipment-row-btn{
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
}

.no-border-input /deep/ .v-input__slot {
  &:before{
    border: none !important;
    border-image: none !important;
  }
}

</style>
